import React from 'react';
import '../auth.css';


const SocialMedia =()=>
{
    return(
      <div className="social" style={{paddingTop:'7px',paddingBottom:'10px'}} >
       
         <img src={require('../pictures/facebook.png')} className="social_image"  alt="social_image" style={{width: '7%',cursor:'pointer'}} onClick={(e) =>   window.open ("https://www.facebook.com/zainjordan","mywindow")}/>
         <img src={require('../pictures/instagram.png')} className="social_image" alt="social_image" style={{width: '7%',cursor:'pointer'}} onClick={(e) =>   window.open ("https://www.instagram.com/zainjo/","mywindow")}/>
         <img src={require('../pictures/twitter.png')} className="social_image" alt="social_image" style={{width: '7%',cursor:'pointer'}} onClick={(e) =>   window.open ("https://twitter.com/zainjo","mywindow")}/>
         <img src={require('../pictures/snapchat.png')} className="social_image" alt="social_image" style={{width: '7%',cursor:'pointer'}} onClick={(e) =>   window.open ("https://www.facebook.com/zainjordan/photos/a.216563588376627.63148.131192906913696/1544053008961005/?type=3&theater","mywindow")}/>
         
      </div>
    );
}

export default SocialMedia;
